module.exports = __webpack_public_path__ + "static/img/SaaS.4f30f0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_educloud/SaaS.jpg
// module id = G+qp
// module chunks = 0